<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md6>
        <material-card
          color="Cyan"
          :title="`Meus Cartões > ${user.name}`"
          text=""
        >
          <v-data-table
            :headers="headers"
            :items="cards"
            hide-actions
            :loading="true"
            :no-data-text="nodatatext"
            v-if="!loading && cards.length > 0"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading text-xs-right font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <tr>
                <td>
                  <img
                    :src="`/icons/cards/${item.brand}.png`"
                    height="70px"
                    align="left"
                  />
                </td>
                <td>
                  **** **** **** {{ item.last_digits }}
                  <p>{{ item.holder_name }}</p>
                  <p v-if="user.card_default === item.id">Principal</p>
                  <p v-if="!item.valid" class="carderror">
                    Cartão expirado ou inválido!
                  </p>
                </td>
                <td class="text-xs-right">
                  {{ item.expiration_date | formatExpirationDate }}
                </td>
                <!-- <td class="text-xs-right"><v-icon color="blue-grey darken-2">edit</v-icon>&nbsp;<v-icon color="red darken-2">delete</v-icon></td> -->
              </tr>
            </template>
          </v-data-table>
          <template v-if="!loading && cards.length <= 0" justify-center>
            <v-card-text>
              <p class="text-md-center">Não há cartões cadastrados</p>
            </v-card-text>
          </template>
          <v-progress-linear
            v-if="loading"
            height="2"
            v-slot:loading
            color="cyan"
            indeterminate
          ></v-progress-linear>
        </material-card>
      </v-flex>
      <v-flex xs12 md6>
        <material-card
          color="green"
          title="Adicionar Cartão de Crédito"
          text=""
        >
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="credit_card"
                    :rules="credit_cardRules"
                    name="credit_card"
                    append-icon="credit_card"
                    label="Número do Cartão"
                    :mask="mask_credit_card"
                  />
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="name"
                    name="name"
                    :rules="nameRules"
                    append-icon="person"
                    class="purple-input"
                    label="Nome do Cartão"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="valid_thru"
                    name="valid_thru"
                    :rules="valid_thruRules"
                    append-icon="event"
                    label="Data de Validade"
                    mask="##/##"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="security_number"
                    name="security_number"
                    :rules="security_numberRules"
                    append-icon="security"
                    label="Código de Segurança"
                    mask="###"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-checkbox
                    v-model="principal"
                    name="principal"
                    label="Cartão Principal"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 text-xs-left>
                  <div>
                    Para sua segurança, nós iremos realizar uma pré autorização
                    no valor de R$ 1,00 no seu cartão. Isso é apenas para
                    verificação e o valor não será debitado da sua conta.
                  </div>
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="success"
                    :loading="loading"
                    @click="validate()"
                    :disabled="!valid || loading"
                  >
                    <v-icon left dark>mdi-credit-card-plus</v-icon>
                    Adicionar Cartão
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
      <v-snackbar
        :color="color"
        :bottom="bottom"
        :top="top"
        :left="left"
        :right="right"
        v-model="snackbar"
        dark
      >
        <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
        <div>{{ snackMessage }}</div>
        <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
// import { updateUser } from '@/services/users'
// import {addBuyer, addCardToken, addTransaction, addCardUser,getCardDetail } from '@/services/creditcards'
import { GET_CARDS_BY_USER, SET_CARD } from "../graphql/cards";
import amplitude from "amplitude-js";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["user"]),
    userId() {
      return this.$store.getters.userId;
    },
  },
  data: () => ({
    cards: [],
    color: null,
    colors: ["purple", "info", "success", "warning", "error"],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackMessage: "",
    snackbar: false,
    nodatatext: "",
    items: [],
    credit_card: "",
    credit_cardRules: [
      (v) => !!v || "Por favor, informe o número do cartão de crédito",
      (v) =>
        v.length >= 16 ||
        "Por favor, o número do cartão de crédito deve conter 16 números.",
    ],
    name: "",
    nameRules: [
      (v) => !!v || "Por favor, informe o nome conforme escrito no cartão.",
      (v) =>
        v.length >= 5 ||
        "Por favor, preencha seu nome conforme escrito no cartão.",
    ],
    valid_thru: "",
    valid_thruRules: [
      (v) => !!v || "Por favor, informe a data de validade do seu cartão.",
      (v) => v.length >= 4 || "Por favor, a data de validade deve ser mm/aa.",
      (v) =>
        !(v.substr(2, 2) < 19) ||
        "Por favor, o ano deve ser igual ou superior 2019.",
      (v) => !(v.substr(0, 2) > 12) || "Por favor, o mes deve ser valido. ",
    ],
    security_number: "",
    security_numberRules: [
      (v) =>
        !!v ||
        "Por favor, informe o código de segurança que está atrás do seu cartão.",
      (v) =>
        v.length >= 3 ||
        "Por favor, o código de segurança deve conter 3 dígitos.",
    ],
    principal: true,
    valid: false,
    loader: null,
    loading_table: true,
    loading: false,
    headers: [
      {
        sortable: false,
        text: "",
        value: "card_brand",
      },
      {
        sortable: false,
        text: "Cartão",
        value: "last4_digits",
      },
      {
        sortable: false,
        text: "Validade",
        value: "expiration_month",
      },
      /*
      {
        sortable: false,
        text: 'Ações'
      }
      */
    ],
    mask_credit_card: "credit-card",
    value: "4444444444444444",
  }),
  created() {
    this.loading = true;
    if (this.user) {
      this.$apollo
        .query({
          // gql query
          query: GET_CARDS_BY_USER,
          // Reactive parameters
          variables: {
            // Use vue reactive properties here
            customer_id: this.user.buyer_id,
          },
        })
        .then((res) => {
          // Seta as faturas no eventBus para o outro Componente
          this.loading = res.loading;
          var eventProperties = {
            customer_id: this.user.customer_id,
          };
          amplitude.getInstance().logEvent("VIEWED_CARD", eventProperties);
          this.cards = res.data.cards;
        })
        .catch((err) => {
          console.error("Error: ", err);
          this.loader = false;
          return err;
        });
    }
  },
  filters: {
    formatExpirationDate(value) {
      if (!value) return "";
      const first = value.substring(0, 2);
      const last2 = value.substring(2, 4);
      return first + "/" + last2;
    },
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        (this.valid = true), (this.loader = null);
        this.loading = true;
        this.saveCard();
      }
    },
    async saveCard() {
      const card = {
        card_number: this.credit_card.replace(/\s/g, ""),
        card_holder_name: this.name,
        card_expiration_date: this.valid_thru,
        card_cvv: this.security_number,
        principal: this.principal,
      };
      // console.log('card: ', card)
      this.$apollo
        .mutate({
          // Query
          mutation: SET_CARD,
          // Parameters
          variables: {
            card_number: card.card_number,
            card_holder_name: card.card_holder_name,
            holder_name: card.holder_name,
            card_expiration_date: card.card_expiration_date,
            card_cvv: card.card_cvv,
            card_default: card.principal,
            external_id: this.user.customer_id,
            customer_id: this.user.buyer_id,
          },
          update: (store, { data: { createCard } }) => {
            const data = store.readQuery({
              query: GET_CARDS_BY_USER,
              variables: {
                customer_id: this.user.buyer_id,
              },
            });
            data.cards.unshift(createCard);
            if (card.principal) {
              // Seta o novo cartão principal na variavel usuário do localhost
              this.user.card_default = createCard.id;
            }
            store.writeQuery({ query: GET_CARDS_BY_USER, data });
          },
        })
        .then((res) => {
          var eventProperties = {
            customer_id: this.user.customer_id,
          };
          amplitude.getInstance().logEvent("ADD_CARD", eventProperties);
          this.loading = res.loading;
          this.snack("Cartão adicionado com sucesso!", "success", "top");
        })
        .catch((error) => {
          this.loading = false;
          this.snack(error.message, "error", "top");
        });
    },
    snack(message, color, ...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
  },

  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 1000);

      this.loader = null;
    },
  },
};
</script>
<style scoped>
.carderror {
  color: red !important;
}
</style>
